module.exports = __webpack_public_path__ + "img/banner-3.6f19eb30.jpg";